/* @ngInject */
const myTable = () => {
  return {
    restrict: 'E',
    scope: {
      myData: '=',
      myNature: '=?',
      myField: '=?',
      enableButtons: '=?',
      enableLinks: '=?',
      enableBadges: '=?',
    },
    template: require('./myTable.html'),

    /* @ngInject */
    controller: ($scope, utils, entities) => {
      $scope.utils = utils

      $scope.fields = entities[$scope.myNature].metadata.fields
      $scope.badges = entities[$scope.myNature].metadata.badges
      $scope.buttons = entities[$scope.myNature].metadata.buttons

      if (!$scope.myField) { $scope.myField = 'details' }

      let index = -1
      $scope.displayBadges = function (i) {
        if (index === -1) index = i
        return index === i
      };
    },

    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs) => { },
    },
  }
}

export default myTable



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/tables/myTable.js